import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerSemantic } from '../colors';

type MuiAlert = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiAlert'];
  defaultProps?: ComponentsProps['MuiAlert'];
  variants?: ComponentsVariants['MuiAlert'];
};

export const MuiAlert: MuiAlert = {
  defaultProps: {
    icon: false,
  },
  styleOverrides: {
    root: {
      alignItems: 'center',
      fontSize: 14,
      padding: '2px 16px',
      lineHeight: '20px',
      '.MuiIconButton-sizeSmall': {
        fontSize: 14,
        '&:active': {
          borderRadius: '3px',
        },
      },
      '.MuiButton-text': {
        fontWeight: '800',
        lineHeight: '14px',
        minHeight: '24px',
        minWidth: 'auto',
        whiteSpace: 'nowrap',
      },
    },
    action: {
      padding: 0,
      alignItems: 'center',
    },
    standardError: {
      color: tannerSemantic.error.color,
      backgroundColor: tannerSemantic.error.background,
      '.MuiIconButton-sizeSmall, .MuiButton-text': {
        color: tannerSemantic.error.color,
        '&:hover': {
          color: tannerSemantic.error['700'],
          backgroundColor: tannerSemantic.error['100'],
        },
      },
    },
    standardInfo: {
      color: tannerSemantic.info.color,
      backgroundColor: tannerSemantic.info.background,
      '.MuiIconButton-sizeSmall, .MuiButton-text': {
        color: tannerSemantic.info.color,
        '&:hover': {
          color: tannerSemantic.info['600'],
          backgroundColor: tannerSemantic.info['100'],
        },
      },
    },
    standardSuccess: {
      color: tannerSemantic.success.color,
      backgroundColor: tannerSemantic.success.background,
      '.MuiIconButton-sizeSmall, .MuiButton-text': {
        color: tannerSemantic.success['500'],
        '&:hover': {
          color: tannerSemantic.success['600'],
          backgroundColor: tannerSemantic.success['100'],
        },
      },
    },
    standardWarning: {
      color: tannerSemantic.warning.color,
      backgroundColor: tannerSemantic.warning.background,
      '.MuiIconButton-sizeSmall, .MuiButton-text': {
        color: tannerSemantic.warning.color,
        '&:hover': {
          color: tannerSemantic.warning['600'],
          backgroundColor: tannerSemantic.warning['100'],
        },
      },
    },
  },
};
